import React from 'react';
import {bourseviewApiUrl} from "../api/apiConst";

const webApiContent = {
    cardSection: {
        leftTopSection: [
            {
                h1Title: {fa: 'مخاطبان وب سرویس پویا', en: 'Pooya API Users'},
                firstParagraph: {
                    fa: 'مخاطبان و کاربران این وب سرویس میتوانند شامل کلیه نهادهای مالی، شرکت‌های تامین سرمایه، مشاوره سرمایه‎گذاری، سبدگردان، سایت‌های خبری، بانک‌ ها، بیمه‎ها و استارتاپ‎های مالی و همچنین شرکت‌های سهامی عام در جهت ارائه اطلاعات منتخب در تارنمای سازمانی و سامانه‌های تحلیلی و مدیریتی و سایر امور پژوهشی و تحقیقاتی باشد.',
                    en: 'Audiences and users of this web service can include all financial institutions, venture capital firms, investment consulting, portfolio companies, news sites, banks, insurance and financial startups as well as publicly traded companies to provide selected information on the corporate Web site. And analytical and management systems and other research and research affairs.'
                },
                iconName: 'team.svg',
                colorClass: 'bg-blue',

            },
            {
                h1Title: {fa: 'تعرفه خدمات', en: 'Service Tariffs'},
                firstParagraph: {
                    fa: 'مبلغ متغیر قرارداد بر اساس میزان استفاده از سرویس و با معیار hits تعیین می گردد. این مبلغ به ازای هر hit دویست ریال (برای اطلاعات قیمتی به ازای هر hit صد ریال) خواهد بود. معیار اندازه ‎گیری میزان استفاده، Hits تعداد رکوردهای برگشت داده شده (نماد، روز، قلم مالی) در خروجی هر API است. برای اطلاعات بیشتر به قسمت تعرفه ها مراجعه نمایید.',
                    en: 'Contract cost is determined by the amount of service used and the hit criteria. This will be two hundred riyals per hit. The criterion for measuring usage is Hits, the number of records returned (stock symbol, charts, financial field) at the output of each API. See the Pricing section for more information.'
                },
                iconName: 'api.svg',
                colorClass: 'bg-blue',

            }
        ],
        // leftBottomSection:[
        //     {
        //         title:{fa:'اطلاعات صورت‎های مالی',en:'criteria in a second '},
        //         iconName:'chart.svg',
        //         colorClass:'bg-blue',
        //     },
        //     {
        //         title:{fa:'اطلاعات بازار',en:'criteria in a second'},
        //         iconName:'chart.svg',
        //         colorClass:'bg-blue',
        //     },
        //     {
        //         title:{fa:'نرخ‎های رشد اقلام بنیادی',en:'criteria in a second'},
        //         iconName:'chart.svg',
        //         colorClass:'bg-blue',
        //     },
        //     {
        //         title:{fa:'نرخ‎های اوراق بازار بدهی',en:'criteria in a second'},
        //         iconName:'chart.svg',
        //         colorClass:'bg-blue',
        //     },
        //     {
        //         title:{fa:'آیتم‎های تکنیکال',en:'criteria in a second'},
        //         iconName:'chart.svg',
        //         colorClass:'bg-blue',
        //     },
        //     {
        //         title:{fa:'آیتم‎های ریسک و بازده',en:'criteria in a second'},
        //         iconName:'chart.svg',
        //         colorClass:'bg-blue',
        //     }
        // ],
        rightSection: {
            header: {fa: 'چرا وب سرویس پویا', en: 'Why Pooya API'},
            items: [
                {
                    title: {fa: 'هزینه مناسب', en: 'Proper Price '},
                    firstParagraph: {
                        fa: 'هزینه استفاده از خدمات وب سرویس پویا در مقایسه با رقبا و خدمات دریافتی کاملا مناسب و اقتصادی است. ',
                        en: 'The cost of using Pooya web services is quite reasonable compared to competitors and received services. '
                    },
                    iconName: 'money-bag.svg',
                    colorClass: 'bg-yellow',
                },
                {
                    title: {fa: 'اعتبار و اعتماد', en: 'Credit and Trust'},
                    firstParagraph: {
                        fa: 'وب سرویس پویا محصول شرکت پردازش اطلاعات مالی مفید، تحت نظارت سازمان بورس و اوراق بهادار و از مجموعه‎های کارگزاری مفید یکی معتبرترین و با قدمت ترین نهادهای مالی کشور است. رضایت و اعتماد مشتریان همواره دارائی اصلی این مجموعه بوده است.',
                        en: ' Pooya Web Service is a product of Pooya Finance Company, supervised by the Securities and Exchange Organization and one of the most prestigious and oldest financial institutions in the country. Customer satisfaction and trust have always been the main asset of this company.'
                    },
                    iconName: 'trust.svg',
                    colorClass: 'bg-red',
                },
                {
                    title: {fa: 'پشتیبانی خدمات', en: 'Support Services'},
                    firstParagraph: {
                        fa: 'تیم پشتیبانی فنی پویا، همواره همراه مشتریان و کاربران خود بوده و در صورت نیاز به خدمات آموزشی و رفع مشکل فنی، امکان ارائه خدمات بصورت حضوری، تلفنی و برخط میسر است. ',
                        en: 'The Pooya technical support team is always in touch with its customers and users, providing online services if training and troubleshooting is needed.'
                    },
                    iconName: 'support.svg',
                    colorClass: 'bg-pink',
                },
                {
                    title: {fa: 'خدمات استاندارد', en: 'Standard Services'},
                    firstParagraph: {
                        fa: 'وب سرویس پویا از استاندارد REST و خروجی اطاعات در قالب استاندارد JSON تبعیت می کند و همچنین پایداری در ارائه خدمات و صحت از ویژگی های اصلی این سرویس است. ',
                        en: 'The Pooya web service complies with the REST and JSON standard outputs of information, as well as the reliability and authenticity of the service.'
                    },
                    iconName: 'ribbon.svg',
                    colorClass: 'bg-purple',
                },
                {
                    title: {fa: 'سهولت استفاده', en: 'Ease of Use'},
                    firstParagraph: {
                        fa: 'قابلیت دسترسی، امکان استفاده از سرویس آزمایشی، عدم پیچیدگی مکاتبات اداری و سرعت در ارائه خدمات از مجموعه عواملی است که استفاده از وب سرویس پویا را سهل و جذاب میکند.',
                        en: 'Accessibility, trial service and the speed of service delivery are numbers of factors that make the use of Pooya web service attractive. '
                    },
                    iconName: 'ui-ux.svg',
                    colorClass: 'bg-cream',
                }
            ]
        },
    },

    leftImage: {
        headerImg: <img alt='' src={require('../assets/images/pic-st1.jpg')}/>,
        button: {textFa: 'ورود به پنل مدیریتی', textEn: 'Login to the admin panel'},
        buttonLink: {link: bourseviewApiUrl, target: ''},
        textContent: [
            {
                bgIconClass: 'bg-orange',
                title: {fa: 'وب سرویس پویا ', en: 'Pooya API'},
                description: {
                    fa: <span>وب سرویس پویا، کلیه اطلاعات معاملاتی لحظه ‎ای بازار و تاریخچه آن،
                        اطلاعیه ها، صورت های مالی و مجامع را به همراه اقلام محاسباتی همچون نسبت ها،
                        نرخ های رشد و ضرایب را در اختیار کاربران خود قرار میدهد.<br/><br/>همزمان با انتشار اطلاعیه ‎های شرکت‎ها در سامانه کدال،
                        کلیه اطلاعات صورت‎های‎ مالی و اقلام محاسباتی بصورت لحظه‌ای قابل دسترس و استفاده کاربران است. 
                        کلیه اقلام و اطلاعات موجود در سامانه بورس ویو، قابل ارائه در قالب وب سرویس به مخاطبان و کاربران است.<br/></span>
                    ,
                    en: <span>
                        Pooya Web Service provides all users with instant marketplace information and its history,
                        announcements, financial statements and forums, along with computational items such as ratios, growth rates and coefficients.
                        <br/><br/>
                        As the company releases announcements on the codal site, 
                        all financial statement and accounting information is instantly accessible and usable by users.
                    </span>
                },
            }
        ]
    },
    // selectableImage:{
    //     title:{fa:'',en:''},
    //     description:{fa:'',en:''},
    //     textContent:[
    //         {
    //             bgIconClass:'bg-orange',
    //             icon:<img alt='' src={require('../assets/images/writing.svg')}/>,
    //             text:{fa:'اطلاعات بازار و صورت های مالی شرکت ها',
    //                 en:'Meet the stocks that meet your criteria in a second '},
    //             img:<img alt='' src={require('../assets/images/pic-3.jpg')} />,
    //         },
    //         {
    //             bgIconClass:'bg-orange',
    //             icon:<img alt='' src={require('../assets/images/writing.svg')}/>,
    //             text:{fa:'اطلاعات بازار و صورت های مالی شرکت هنرخ های رشد اقلام کلیدی و اوراق بازار بدهی ',
    //                 en:'Meet the stocks that meet your criteria in a second '},
    //             img:<img alt='' src={require('../assets/images/pic-3.jpg')} />,
    //         },
    //         {
    //             bgIconClass:'bg-orange',
    //             icon:<img alt='' src={require('../assets/images/writing.svg')}/>,
    //             text:{fa:'آیتم های تکنیکال ریسک و بازده',
    //                 en:'Meet the stocks that meet your criteria in a second '},
    //             img:<img alt='' src={require('../assets/images/man-pic-2.jpg')} />,
    //         }
    //     ]
    // }
}


export default webApiContent;